import React from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import { useGetJournalEventsContext } from '@entities/eventJournal/api/hooks';
import { getEstimateName } from '@entities/eventJournal/lib';
import { useTextEventJournalItem } from '@entities/eventJournal/lib/hooks';
import { IJournalEvent } from '@entities/eventJournal/model/types';
import { changeTariff } from '@entities/tariff/lib';

import cls from './EventJournalItemList.module.css';
import { PhotoEventJournalItem } from '../PhotoEventJournalItem/PhotoEventJournalItem';
import { TextEventJournalItem } from '../TextEventJournalItem/TextEventJournalItem';

interface EventItemListProps {
    classes?: string;
    header: React.ReactNode;
    photoEvents: IJournalEvent[];
    textEvents: IJournalEvent[];
    isExport?: boolean;
}

export const EventJournalItemList = ({
    classes,
    header,
    photoEvents,
    textEvents,
    isExport = false,
}: EventItemListProps) => {
    const { handleTextEventClick } = useTextEventJournalItem();
    const { data: filtersData, isSuccess } = useGetJournalEventsContext();

    const { is_owner: isOwner } = useSelector(
        // @ts-ignore
        (state) => state.dashboardReducer
    );

    return (
        <div className={cn(cls.EventItemList, [classes])}>
            {header}
            <div
                className={cn(cls.EventItemListBody, {
                    [cls.export]: isExport,
                })}
            >
                {!!textEvents.length && (
                    <div className={cls.textEvents}>
                        {textEvents.map((textEvent) => (
                            <TextEventJournalItem
                                key={textEvent.id}
                                textEvent={textEvent}
                                isExport={isExport}
                                onClick={
                                    isExport
                                        ? null
                                        : async () => {
                                              if (!filtersData?.canCreateCustomEvent) {
                                                  await changeTariff(isOwner);
                                                  return;
                                              }

                                              handleTextEventClick(textEvent.id, textEvent.type);
                                          }
                                }
                                estimateName={getEstimateName({
                                    estimatesData: filtersData?.estimates,
                                    estimateId: textEvent.estimateId,
                                    isSuccess,
                                })}
                            />
                        ))}
                    </div>
                )}
                {!!photoEvents.length && (
                    <div className={cls.photoEvents}>
                        <PhotoEventJournalItem
                            isExport={isExport}
                            photoEvents={photoEvents}
                            isOnlyPhoto={!textEvents.length}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
